import React from 'react'
import {GET_COMPANY} from '../../Companies/graphql'
import {Query} from 'react-apollo'
import BlockWithLoader from '../../Support/BlockWithLoader'
import CompanyForm from '../../Companies/CompanyForm'

const CompanyTab = () => {
  return (
    <Query query={GET_COMPANY} variables={{main: true}} fetchPolicy='network-only'>
      {({data, loading, error}) => {
        if (error) return <div>An unexpected error occurred{JSON.stringify(error)}</div>

        return (
          <BlockWithLoader loading={loading} renderChildren={true}>
            {!loading &&
            <CompanyForm company={data.company}
              afterSubmit={()=>{}}
            />
            }
          </BlockWithLoader>
        )
      }}
    </Query>
  )
}

export default CompanyTab



// WEBPACK FOOTER //
// ./src/components/Profile/tabs/CompanyTab.js